import { isMobile } from 'react-device-detect'
import { push } from 'connected-react-router'
import { IChecklist, IFeatureAvailabilityParams } from 'app/domains/routes/Dashboard/OnboardingChecklist/interface'
// @ts-ignore
import { onboardingId as idOfDidTodayActivity } from 'app/domains/routes/Dashboard/UserActivityBlock/UserActivityControlPanel/UserActivityControlPanelActivityActions/UserActivityControlPanelActivityActions'
// @ts-ignore
import { onboardingId as idOfDidYesterdayActivity } from 'app/domains/routes/Dashboard/UserYesterdayActivity/UserYesterdayActivity'
// @ts-ignore
import { dashboardMenuItemClass } from 'app/domains/routes/Dashboard/UserBoard/Main/UserBoardMain'
import { modal } from 'store/entities/modal/actions'
// @ts-ignore
import { store } from 'store'

const hideModalAtMobile = () => {
  if (isMobile) {
    store.dispatch(modal.hide())
  }
}
let linkTimeout: NodeJS.Timeout

const hideFocusModal = (target: any) => {
  store.dispatch(modal.hide())
  target.style.zIndex = 1
  clearTimeout(linkTimeout)
}

export const scrollToActionButton = async () => {
  await store.dispatch(push('/dashboard'))
  hideModalAtMobile()
  const todayActionButton = document.getElementById(`${idOfDidTodayActivity}`) as any
  const yesterdayActionButton = document.getElementById(`${idOfDidYesterdayActivity}`) as any
  const target = yesterdayActionButton || todayActionButton
  target.scrollIntoView({ block: 'end', inline: 'nearest' })
  target.style.zIndex = 1000
  store.dispatch(modal.show())
  linkTimeout = setTimeout(() => hideFocusModal(target), 4000)
}

export const scrollToStoryInput = async () => {
  await store.dispatch(push('/dashboard'))
  window.scrollTo(0, 0)
  hideModalAtMobile()
}

export const switchToNotificationsTab = async () => {
  await store.dispatch(push('/dashboard'))
  const event = new CustomEvent('click', { bubbles: true })
  const notificationsTab = document.getElementById(`${dashboardMenuItemClass}_notifications`) as any
  notificationsTab.dispatchEvent(event)
  hideModalAtMobile()
}

export const scrollToUserBoard = async () => {
  await switchToNotificationsTab()
  const userBoard = document.getElementById('user-board') as any
  userBoard.scrollIntoView()
}

export interface IGetCheckListAvailabilityParams {
  checklist: IChecklist
  featureAvailabilityParams: IFeatureAvailabilityParams
}

export const getCheckListAvailabilityParams = ({
  checklist,
  featureAvailabilityParams,
}: IGetCheckListAvailabilityParams) => {
  const {
    isFirstActionCompleted,
    isStoryShared,
    isMobileNumberAdded,
    areNotificationSettingsUpdated,
    isQuizCompleted,
  } = checklist
  const { isStoriesEnabled, isSMSEnabled, isSurveyEnabled } = featureAvailabilityParams
  const defaultChecklistLength = 5

  const availableOrgFeatureNumber =
    defaultChecklistLength - Number(!isStoriesEnabled) - Number(!isSMSEnabled) - Number(!isSurveyEnabled)
  const completedNumber =
    Number(isFirstActionCompleted) +
    Number(isStoriesEnabled && isStoryShared) +
    Number(isSMSEnabled && isMobileNumberAdded) +
    Number(areNotificationSettingsUpdated) +
    Number(isSurveyEnabled && isQuizCompleted)

  return { completedNumber, availableOrgFeatureNumber }
}
